<template>
<div>
<h1> {{title}} </h1>
<h2> Compiled on {{date}} </h2>
<svg id='graphview'></svg>
<br/>
<br/>
<br/>
</div>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'GraphView',
  props: {
    title: String,
    query_data: Object,
    date: String
  },
  data () {
    return {
      data: this.query_data
    }
  },
  mounted () {
    this.generateArc()
  },
  methods: {
    generateArc () {
      console.log(JSON.parse(JSON.stringify(this.data)))
      console.log('data before force')

      var width = 800
      var height = 600
      var color = d3.scaleOrdinal(d3.schemeCategory10)

      // var graph = JSON.parse(JSON.stringify(this.data))
      var graph = Object.assign({}, this.data)
      console.log('graph:')
      console.log(graph)

      var label = {
        'nodes': [],
        'links': []
      }

      console.log(graph.nodes)
      graph.nodes.forEach(function (d, i) {
        label.nodes.push({node: d})
        label.nodes.push({node: d})
        label.links.push({
          source: i * 2,
          target: i * 2 + 1
        })
      })

      console.log('labels.nodes')
      console.log(label.nodes)

      var labelLayout = d3.forceSimulation(label.nodes)
        .force('charge', d3.forceManyBody().strength(-50))
        .force('link', d3.forceLink(label.links).distance(0).strength(2))

      var graphLayout = d3.forceSimulation(graph.nodes)
        .force('charge', d3.forceManyBody().strength(-3000))
        .force('center', d3.forceCenter(width / 2, height / 2))
        .force('x', d3.forceX(width / 2).strength(1))
        .force('y', d3.forceY(height / 2).strength(1))
        .force('link', d3.forceLink(graph.links).id(function (d) { return d.id }).distance(50).strength(1))
        .on('tick', ticked)

      var adjlist = []

      graph.links.forEach(function (d) {
        adjlist[d.source.index + '-' + d.target.index] = true
        adjlist[d.target.index + '-' + d.source.index] = true
      })

      function neigh (a, b) {
        return a === b || adjlist[a + '-' + b]
      }

      var svg = d3.select('#graphview').attr('width', width).attr('height', height)
      var container = svg.append('g')

      svg.call(
        d3.zoom()
          .scaleExtent([0.1, 4])
          .on('zoom', function (event) { container.attr('transform', event.transform) })
      )

      var link = container.append('g').attr('class', 'links')
        .selectAll('line')
        .data(graph.links)
        .enter()
        .append('line')
        .attr('stroke', '#aaa')
        // .attr('stroke-width', '1px')
        .attr('stroke-width', function (d) { return d.value / 5 })

      var node = container.append('g').attr('class', 'nodes')
        .selectAll('g')
        .data(graph.nodes)
        .enter()
        .append('circle')
        .attr('r', 5)
        .attr('fill', function (d) { return color(d.group) })

      node.on('mouseover', focus).on('mouseout', unfocus)

      node.call(
        d3.drag()
          .on('start', dragstarted)
          .on('drag', dragged)
          .on('end', dragended)
      )

      var labelNode = container.append('g').attr('class', 'labelNodes')
        .selectAll('text')
        .data(label.nodes)
        .enter()
        .append('text')
        .text(function (d, i) { return i % 2 === 0 ? '' : d.node.id })
        .style('fill', '#555')
        .style('font-family', 'Arial')
        .style('font-size', 12)
        .style('pointer-events', 'none') // to prevent mouseover/drag capture
      node.on('mouseover', focus).on('mouseout', unfocus)

      function ticked () {
        node.call(updateNode)
        link.call(updateLink)
        labelLayout.alphaTarget(0.3).restart()
        labelNode.each(function (d, i) {
          if (i % 2 === 0) {
            d.x = d.node.x
            d.y = d.node.y
          } else {
            var b = this.getBBox()
            var diffX = d.x - d.node.x
            var diffY = d.y - d.node.y
            var dist = Math.sqrt(diffX * diffX + diffY * diffY)
            var shiftX = b.width * (diffX - dist) / (dist * 2)
            shiftX = Math.max(-b.width, Math.min(0, shiftX))
            var shiftY = 16
            this.setAttribute('transform', 'translate(' + shiftX + ',' + shiftY + ')')
          }
        })
        labelNode.call(updateNode)
      }

      function fixna (x) {
        if (isFinite(x)) return x
        return 0
      }

      function focus (d) {
        var index = d3.select(this).datum().index
        node.style('opacity', function (o) {
          return neigh(index, o.index) ? 1 : 0.1
        })
        labelNode.attr('display', function (o) {
          return neigh(index, o.node.index) ? 'block' : 'none'
        })
        link.style('opacity', function (o) {
          return o.source.index === index || o.target.index === index ? 1 : 0.1
        })
      }

      function unfocus () {
        labelNode.attr('display', 'block')
        node.style('opacity', 1)
        link.style('opacity', 1)
      }

      function updateLink (link) {
        link.attr('x1', function (d) { return fixna(d.source.x) })
          .attr('y1', function (d) { return fixna(d.source.y) })
          .attr('x2', function (d) { return fixna(d.target.x) })
          .attr('y2', function (d) { return fixna(d.target.y) })
      }

      function updateNode (node) {
        node.attr('transform', function (d) {
          return 'translate(' + fixna(d.x) + ',' + fixna(d.y) + ')'
        })
      }

      function dragstarted (event, d) {
        event.sourceEvent.stopPropagation()
        if (!event.active) graphLayout.alphaTarget(0.3).restart()
        d.fx = d.x
        d.fy = d.y
      }

      function dragged (event, d) {
        d.fx = event.x
        d.fy = event.y
      }

      function dragended (event, d) {
        if (!event.active) graphLayout.alphaTarget(0)
        d.fx = null
        d.fy = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GraphView.vue